if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"core_hr","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2(167|368|601|987)|6(127|136|565)|(493|739|82)9|1021|5363|5704|7895|8361|9427)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}